import React from "react";
import { useTranslation } from "react-i18next";

import { DateTimeInput } from "@common/dateTimeInput";
import { TextInput } from "@common/textInput";
import { ListSelect } from "@common/listSelect";
import { RichTextInput } from "@common/richTextInput";
import { Props } from "./types";
import styles from "./styles.scss";
import { ProjectsSelection } from "@common/projectsSelection";

function MilestoneCreationForm({
  formData,
  lists,
  isMultiProject,
  error,
  editForm,
  onProjectChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.milestoneCreationForm}>
      {isMultiProject && (
        <div className={styles.projectSelectionRow}>
          <div className={styles.group}>
            <h3 className={styles.title}>{t("milestoneCreation.inProject")}</h3>
            <ProjectsSelection
              placeholder={t("milestoneCreation.projectSelectionPlaceholder")}
              onSelectProject={(selectedProject) => {
                onProjectChange?.(selectedProject);
              }}
            />
          </div>
        </div>
      )}
      <div className={styles.group}>
        <h3 className={styles.title}>{t("milestoneCreation.nameTitle")}</h3>
        <div className={styles.textInput}>
          <TextInput
            value={formData.name}
            placeholder={t("milestoneCreation.namePlaceholder")}
            input={(name) => editForm({ ...formData, name })}
            isInvalid={error.duplicateName || error.emptyName}
            autoFocus
          />
        </div>
      </div>
      <div className={styles.dateGroup}>
        <div className={styles.row}>
          <h3 className={styles.title}>
            {t("milestoneCreation.endDateTitle")}
          </h3>
          <div className={styles.dateTimeInput}>
            <DateTimeInput
              dateTime={formData.endDate}
              placeholder={t("milestoneCreation.endDatePlaceholder")}
              input={(endDate) => editForm({ ...formData, endDate })}
              clear={() => editForm({ ...formData, endDate: "" })}
              isInvalid={error.endDateOutOfBound}
              minDate={
                formData.list.startDate
                  ? {
                      year: new Date(formData.list.startDate).getFullYear(),
                      month: new Date(formData.list.startDate).getMonth(),
                      day: new Date(formData.list.startDate).getDate(),
                    }
                  : {
                      year: new Date(formData.list.minStartDate).getFullYear(),
                      month: new Date(formData.list.minStartDate).getMonth(),
                      day: new Date(formData.list.minStartDate).getDate(),
                    }
              }
            />
          </div>
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>
          {t("milestoneCreation.parentListTitle")}
        </h3>
        <div className={styles.listSelect}>
          <ListSelect
            lists={lists}
            selectedList={formData.list}
            selectList={(list) => editForm({ ...formData, list, endDate: "" })}
          />
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>
          {t("milestoneCreation.descriptionTitle")}
        </h3>
        <RichTextInput
          value={formData.description}
          maxLength={10000}
          placeholder={t("milestoneCreation.descriptionPlaceholder")}
          input={(description) => editForm({ ...formData, description })}
        />
      </div>
    </div>
  );
}

export { MilestoneCreationForm };
